import React from 'react'

const ProjectHeaderDetails = ({data}) => {
  return (
    <>
        <div className='project-det-hero-cover'>
                            <div className='row'>
                                <div className='col-lg-6'>
                                    <div className='project-det-title'>
                                        <h3>{data.title}
                                        <span><div className="project-infographics-cover">
                                            <div className="project-info-pills-cover">
                                                <div className="project-info-pills">
                                                    <p>Jan 2024</p>
                                                </div>
                                                <div className="project-info-pills">
                                                    <p>Link</p>
                                                </div>
                                                <div className="project-info-pills">
                                                    <p>Personal Project</p>
                                                </div>
                                            </div>
                                        </div>
                                        </span>
                                            {/* <span className="project-info-pills">
                                                Jan 2024
                                            </span>
                                            <span className="project-info-pills">
                                                Link
                                            </span>
                                            <span className="project-info-pills">
                                                Personal Project
                                            </span> */}
                                        </h3>
                                        
                                        
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className='project-det-short-summary'>
                                        <p>A React app for seamless expense management. Track, categorize, and analyze your spending effortlessly. User-friendly interface, real-time updates, and insightful reports for better financial control. Simplify budgeting with Expend Tracker.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
    </>
  )
}

export default ProjectHeaderDetails